export const getEnv = (key: string) => {
  // eslint-disable-next-line no-underscore-dangle
  return process.env.NODE_ENV === "development" ? process.env[key] : (window as any)._env_[key];
};
